export const logo = 'https://www.freepnglogos.com/uploads/walmart-logo-7.jpeg'